<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="default-filter-new-btn"
          variant="primary"
          type="button"
          class="default-filter-new-btn"
          @click="createDepartment"
        >
          {{ t('Create Department') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>
<script>
import { BButton } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import AppFilter from '@/components/AppFilter/AppFilter.vue';

export default {
  components: {
    BButton,
    AppFilter
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      filterConfig: [
        {
          id: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Name'
        },
        {
          id: 'postalCode',
          label: 'Postal Code',
          type: 'text',
          placeholder: 'Postal Code'
        },
        {
          id: 'email',
          label: 'Email',
          type: 'text',
          placeholder: 'Email'
        },
        {
          id: 'phoneNumber',
          label: 'Phone Number',
          type: 'text',
          placeholder: 'Phone Number'
        },
        {
          id: 'address',
          label: 'Address',
          type: 'text',
          placeholder: 'Address'
        }
      ]
    };
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    },
    createDepartment() {
      this.$router.push({ name: 'create_department' });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
